export default __webpack_public_path__ + "static/media/empty-list-cactus-transparent.63fe9be5.png";